import React, { useState, useMemo } from 'react';
import { Container, Col } from "react-bootstrap";
import { StyledKfTable } from '../../../../Styling/styledTable/StyledTable';
// import UseTableSorter from '../../../components/useTable/UseTable';
import usePaginator from '../../../../components/useTable/UsePaginator';
import UseTableSorter from '../../../../components/useTable/UseTable';
import { TableBorder, TitleSectionTables, KredittvurderingForm, KredittvurderingTd, StyledKvTable } from '../../../../Styling/styledKredittvurdering/styledKvComponents';


const PantTable = (props) => {

    const localeMessages = props.localeMessages
    const kvState = props.kredittvurderingState;
    const ratingData = props.fetchedRating;

    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('documentNumber');    // feltnavn
    const [currentType, setCurrentType] = useState('string'); // num
    const [sortClicked, setSortClicked] = useState(0);

    const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Nødvendig pga henting av memoised felt
    const t1ChangeSortField = (fieldName, fieldType) => {
        masterT1ChangeSortField(fieldName, fieldType)

        // Sett trigger for å tvinge memoized function til rerender
        setSortClicked(Date.now())
    }

    const sortedData = useMemo(
        () => {
            if (ratingData.length > 0) {
                return ratingData.sort(t1GetSortFunc().fn)
            }
            else {
                return []
            }
        },
        [ratingData, sortClicked]
    );

    const formatDescriptionCell = (arr) => arr.map(x => x.description).join(', ');

    // state for grid paginator
    const [numberPrPage, setNumberPerPage] = useState(5)
    const [activePage, setActivePage] = useState(1);

    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        sortedData,
        numberPrPage, setNumberPerPage,
        activePage, setActivePage
    )
    
    const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
      return (
          <thead>
              <tr>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('asset', 'string')}>{localeMessages['GH_asset']}{t1IndicaterIcon('asset')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('documentNumber', 'string')}>{localeMessages['GH_documentNumber']}{t1IndicaterIcon('documentNumber')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('enforced', 'string')}>{localeMessages['GH_enforced']}{t1IndicaterIcon('enforced')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('expiryDateLegalProtection', 'string')}>{localeMessages['GH_expiryDateLegalProtection']}{t1IndicaterIcon('expiryDateLegalProtection')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('roles', 'string')}>{localeMessages['GH_roleOrgId']}{t1IndicaterIcon('roles')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('roles', 'string')}>{localeMessages['GH_roleName']}{t1IndicaterIcon('roles')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('roles', 'string')}>{localeMessages['GH_roleOrgIdSetter']}{t1IndicaterIcon('roles')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('roles', 'string')}>{localeMessages['GH_roleNameSetter']}{t1IndicaterIcon('roles')}</th>
              </tr>
          </thead>
      )
    }


    const printRow = (model) => {
        return (
            <tr key={model.i}>
               <KredittvurderingTd>{model.asset.type}</KredittvurderingTd>
               <KredittvurderingTd>{model.documentNumber}</KredittvurderingTd>
               <KredittvurderingTd>{model.enforced}</KredittvurderingTd>
               <KredittvurderingTd>{model.expiryDateLegalProtection}</KredittvurderingTd>
               <KredittvurderingTd>{model.roles[0]?.roleHolder.organisationId}</KredittvurderingTd>
               <KredittvurderingTd>{model.roles[0]?.roleHolder.name}</KredittvurderingTd>
               <KredittvurderingTd>{model.roles[1]?.roleHolder.organisationId}</KredittvurderingTd>
               <KredittvurderingTd>{model.roles[1]?.roleHolder.name}</KredittvurderingTd>
           </tr>
        )
    }

    return (
        <>
            <Container fluid="true">
                <TableBorder>
                    <KredittvurderingForm>
                        <Col xs={12} md={12}>
                            <TitleSectionTables>Pant (Forpliktet)</TitleSectionTables>
                            <PaginationDropdown />
                            <StyledKvTable>
                                {printHeader(t1IndicaterIcon, t1ChangeSortField)}

                                <tbody>
                                    <Paginate>
                                        {/* paginate forventer en funksjon */}
                                        {row => printRow(row)}
                                    </Paginate>
                                </tbody>
                            </StyledKvTable>
                            <br />
                            <PaginationIndex />
                            <br />
                            <PaginationNav />
                            <br/>
                        </Col>
                    </KredittvurderingForm>
                </TableBorder>            
            </Container>

        </>
    )
}

export default PantTable



